import React from 'react';
import { useNavigate } from 'react-router-dom';
import ProductTopSection from '../../../../components/Sangjo-Ujieon/ProductTopSection';
import ProductSubHeading from '../../../../components/Sangjo-Ujieon/ProductSubHeading';
import FuneralTabPC from '../../../../components/Sangjo-Ujieon/FuneralTabPC';
import { IoIosArrowForward } from "react-icons/io";

const GeneralFuneralProceduresPC = () => {

  return (
    <div className="announcement-list-page product-info-page">
      <ProductTopSection />

      {/* Main Content */}
      <main className="main-content">
        <ProductSubHeading heading="장례정보" />

        <FuneralTabPC />

        {/* Main Content */}
        <div className="general-funeral-procedures-main-content">
          <div className="general-funeral-procedures-page-content general-funeral-procedures-container">

            {/* First Day */}
            <div className="general-funeral-procedures-day-section">
              <h2 className="general-funeral-procedures-day-title">첫째 날</h2>
              <div className="general-funeral-procedures-day-section-content">
                <div className="general-funeral-procedures-procedure">
                  <div className="general-funeral-procedures-procedure-circle">
                    <div className="general-funeral-procedures-procedure-circle-text">
                      <div>임종</div>
                      <div>臨終</div>
                    </div>
                  </div>
                  <div className="general-funeral-procedures-procedure-content">
                    <h3 className="general-funeral-procedures-procedure-title">임종(臨終)</h3>
                    <p className="general-funeral-procedures-procedure-description">
                      가족이나 가까운 혈족이 운명할 때 곁에서 지켜보는 것을 말하며, 임종이 가까워 지면 평소에 입던 옷 중에서 흰색이나 엷은 색의 깨끗한 옷을 갈아 입히고 거처하던 방과 운명한 뒤 모실 방도 깨끗하게 치워둔다. 유언(遺言)이 있으면 침착한 마음으로 기록하거나 녹음해 두고 운명 전에 가장 보고싶어 하는 친족 친지에게 속히 연락하여 운명을 지켜볼 수 있도록 한다.
                    </p>
                  </div>
                </div>

                <div className="general-funeral-procedures-procedure">
                  <div className="general-funeral-procedures-procedure-circle">
                    <div className="general-funeral-procedures-procedure-circle-text">
                      <div>수시</div>
                      <div>收屍</div>
                    </div>
                  </div>
                  <div className="general-funeral-procedures-procedure-content">
                    <h3 className="general-funeral-procedures-procedure-title">수시(收屍)</h3>
                    <p className="general-funeral-procedures-procedure-description">
                      먼저 눈을 곱게 감도록 쓸어 내리고 몸을 반듯하게 한 다음 손과 발을 매만져 가지런히 한다. 머리를 약간 높게하여 괴고 깨끗한 솜으로 코와 귀를 막는다.
                    </p>
                    <p className="general-funeral-procedures-procedure-description">
                      시신을 칠성판 위에 뉘이고 몸을 반듯이 하여 손과 발을 묶고 칠성판에 고정한 뒤 칠성판 밑에 받침목을 고인다. 이를 수시 또는 정제 수시라 한다. 얼굴에 백포를 씌우고 홑이불을 머리까지 덮은 뒤 병풍이나 장막으로 가린 다음 빈소를 마련한다.
                    </p>
                  </div>
                </div>

                <div className="general-funeral-procedures-procedure">
                  <div className="general-funeral-procedures-procedure-circle">
                    <div className="general-funeral-procedures-procedure-circle-text">
                      <div>발상</div>
                      <div>發喪</div>
                    </div>
                  </div>
                  <div className="general-funeral-procedures-procedure-content">
                    <h3 className="general-funeral-procedures-procedure-title">발상(發喪)</h3>
                    <p className="general-funeral-procedures-procedure-description">
                      초상을 알리고 상례를 시작하는 절차이며 수시가 끝나면 가족은 곧 검소한 옷으로 갈아입고 근신하며 애도하되, 호곡은 삼가한다.
                    </p>
                    <p className="general-funeral-procedures-procedure-description">
                      흔히 근조(謹弔)라고 쓰인 등을 달아 놓거나 상중(喪中). 또는 기중(忌中)이라 쓰인 네모난 종이를 대문에 붙여 초상을 알린다.
                    </p>
                  </div>
                </div>

                <div className="general-funeral-procedures-procedure">
                  <div className="general-funeral-procedures-procedure-circle">
                    <div className="general-funeral-procedures-procedure-circle-text">
                      <div>부고</div>
                      <div>訃告</div>
                    </div>
                  </div>
                  <div className="general-funeral-procedures-procedure-content">
                    <h3 className="general-funeral-procedures-procedure-title">부고(訃告)</h3>
                    <p className="general-funeral-procedures-procedure-description">
                      호상은 상주와 의논하여 고인이나 상제와 가까운 친척에게 부고를 낸다. 부고는 반드시 장일과 장지를 기록해야한다.
                    </p>
                    <p className="general-funeral-procedures-procedure-description">
                      가정의례준칙에는 인쇄물에 의한 개별 고지는 금지되어 있지만 구두(口頭)나 사신(私信)으로 알리는 것은 허용된다. 요즘은 전화로 대신한다.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Second Day */}
            <div className="general-funeral-procedures-day-section">
              <h2 className="general-funeral-procedures-day-title">둘째 날</h2>

              <div className="general-funeral-procedures-day-section-content">

                <div className="general-funeral-procedures-procedure">
                  <div className="general-funeral-procedures-procedure-circle">
                    <div className="general-funeral-procedures-procedure-circle-text">
                      <div>염습</div>
                      <div>殮襲</div>
                    </div>
                  </div>
                  <div className="general-funeral-procedures-procedure-content">
                    <h3 className="general-funeral-procedures-procedure-title">염습(殮襲)</h3>
                    <p className="general-funeral-procedures-procedure-description">
                      운명한지 하루가 지나면 시신을 깨끗이 닦고 수의(壽衣)를 입힌다. 여러 개의 수의를 한번에 입힐 수 있도록 준비해 두며 시신을 깨끗이 닦은 후 겹쳐진 옷을 아래옷 부터 웃옷의 차례로 입힌다. 옷 고름은 매지 않으며 옷깃은 산사람과 반대로 오른쪽으로 여미고 옷을 다 입히고 손발을 가지런히 놓고 이불로 싼 뒤 멧베를 잘라 죄어 맨다.
                    </p>
                  </div>
                </div>

                <div className="general-funeral-procedures-procedure">
                  <div className="general-funeral-procedures-procedure-circle">
                    <div className="general-funeral-procedures-procedure-circle-text">
                      <div>사망신고와</div>
                      <div className="teal-color">매장신고</div>
                    </div>
                  </div>
                  <div className="general-funeral-procedures-procedure-content">
                    <h3 className="general-funeral-procedures-procedure-title">사망신고와 매장신고</h3>
                    <p className="general-funeral-procedures-procedure-description">
                      사망진단서 발급 사설묘지 경우 묘지 사용 승낙서 발급관할 주소지 동사무소에 사망신고와 매장신고를 한다.
                    </p>
                  </div>
                </div>

                <div className="general-funeral-procedures-procedure">
                  <div className="general-funeral-procedures-procedure-circle">
                    <div className="general-funeral-procedures-procedure-circle-text">
                      <div>입관</div>
                      <div>入棺</div>
                    </div>
                  </div>
                  <div className="general-funeral-procedures-procedure-content">
                    <h3 className="general-funeral-procedures-procedure-title">입관(入棺)</h3>
                    <p className="general-funeral-procedures-procedure-description">
                      염습이 끝나면 곧 입관한다. 이 때 시신과 관 벽 사이의 공간을 꼭꼭 채워 시신이 관 안에서 흔들리지 않도록 한다. 시신을 고정시키고 관 뚜껑을 덮은 다음 은정을 박고 끈으로 묶는다. 입관이 끝나면 관 밑에 받침을 고이고 안치한 다음 관보를 덮어둔다. 관은 병풍으로 가린다.
                    </p>
                  </div>
                </div>

                <div className="general-funeral-procedures-procedure">
                  <div className="general-funeral-procedures-procedure-circle">
                    <div className="general-funeral-procedures-procedure-circle-text">
                      <div>성복</div>
                      <div>成服</div>
                    </div>
                  </div>
                  <div className="general-funeral-procedures-procedure-content">
                    <h3 className="general-funeral-procedures-procedure-title">성복(成服)</h3>
                    <p className="general-funeral-procedures-procedure-description">
                      입관이 끝나면 영좌를 마련한 뒤 상제(喪制)와 복인(服人)은 성복을 한다, 성복이란 정식으로 상복을 입는다는 뜻이다. 요즘은 전통상복인 굴건제복을 하지 않고 남자는 간단히 베나 광목으로 된 두루마기를 입거나 검은 양복에 무늬 없는 흰 와이셔츠를 입고 검은 넥타이를 매여 여지는 흰색이나 검은색 치마 저고리를 입고 흰색 버선과 고무신을 신는다. 집안의 생활 양식에 따라 검은색 양장을 하기도 하며 물론 양말이나 구두도 검정색으로 통일하는 것이 좋다. 복인은 삼배로 만든 완장이나 두건을 쓴다. 성복을 한 후에는 외인의 문상을 받는다.
                    </p>
                  </div>
                </div>

                <div className="general-funeral-procedures-procedure">
                  <div className="general-funeral-procedures-procedure-circle">
                    <div className="general-funeral-procedures-procedure-circle-text">
                      <div>조문</div>
                      <div>弔問</div>
                    </div>
                  </div>
                  <div className="general-funeral-procedures-procedure-content">
                    <h3 className="general-funeral-procedures-procedure-title">조문(弔問)</h3>
                    <p className="general-funeral-procedures-procedure-description">
                      조객은 영좌 앞에 꿇어앉아 분향하고 두 분 절하고 상주와 인사 할 때는 "얼마나 슬프십니다?"등의 위로의 말과 상주는 "망극하옵니다." 등 간단한 말로서 조문을 받는다. 표준 가정의례에 따라 조객에 대한 음식 접대는 하지 않는다.
                    </p>
                  </div>
                </div>

              </div>
            </div>

            {/* Third Day */}
            <div className="general-funeral-procedures-day-section">
              <h2 className="general-funeral-procedures-day-title">셋째 날</h2>

              <div className="general-funeral-procedures-day-section-content">

                <div className="general-funeral-procedures-procedure">
                  <div className="general-funeral-procedures-procedure-circle">
                    <div className="general-funeral-procedures-procedure-circle-text">
                      <div>발인</div>
                      <div>發靷</div>
                    </div>
                  </div>
                  <div className="general-funeral-procedures-procedure-content">
                    <h3 className="general-funeral-procedures-procedure-title">발인(發靷)</h3>
                    <p className="general-funeral-procedures-procedure-description">
                      영구가 집을 떠나는 절차이다 발인에 앞서 간단한 제물을 차려 놓고 제사를 올린다.
                    </p>
                  </div>
                </div>

                <div className="general-funeral-procedures-procedure">
                  <div className="general-funeral-procedures-procedure-circle">
                    <div className="general-funeral-procedures-procedure-circle-text">
                      <div>영결식</div>
                      <div></div>
                    </div>
                  </div>
                  <div className="general-funeral-procedures-procedure-content">
                    <h3 className="general-funeral-procedures-procedure-title">영결식</h3>
                    <p className="general-funeral-procedures-procedure-description">
                      영결식장은 상가 또는 기타 편리한 장소에 마련한다. 예정된 시간에 영구를 식장에 옮기고, 옆에 영정을 세우며 제단에 사진을 놓고 촛대, 향로 및 향을 준비한다. 영결식순은 다음과 같다.
                    </p>
                    <br />
                    <p className="general-funeral-procedures-procedure-description">
                      개식 &nbsp;<IoIosArrowForward /> &nbsp;상제의 분향배레 &nbsp;<IoIosArrowForward /> &nbsp;고인의 약력보고 &nbsp;<IoIosArrowForward /> &nbsp;조사·조가 &nbsp;<IoIosArrowForward /> &nbsp;조객분향 &nbsp;<IoIosArrowForward /> &nbsp;호상인사 &nbsp;<IoIosArrowForward /> &nbsp;폐식
                    </p>
                  </div>
                </div>

                <div className="general-funeral-procedures-procedure">
                  <div className="general-funeral-procedures-procedure-circle">
                    <div className="general-funeral-procedures-procedure-circle-text">
                      <div>운구</div>
                      <div>運柩</div>
                    </div>
                  </div>
                  <div className="general-funeral-procedures-procedure-content">
                    <h3 className="general-funeral-procedures-procedure-title">운구(運柩)</h3>
                    <p className="general-funeral-procedures-procedure-description">
                      발인제가 끝난 뒤 영구를 장지나 화장장까지 장의차나 상여로 운반하는 절차이다. 장의차를 이용할 때 상제는 영구를 차에 싣는 것을 지켜본다.
                    </p>
                    <p className="general-funeral-procedures-procedure-description">
                      승차 때는 영정 상제 조객 순으로 오른다. 상여를 이용할 때는 운아, 공포, 명정, 만장, 영정, 영구, 상제, 조객 순으로 행렬을 지어간다.
                    </p>
                  </div>
                </div>

                <div className="general-funeral-procedures-procedure">
                  <div className="general-funeral-procedures-procedure-circle">
                    <div className="general-funeral-procedures-procedure-circle-text">
                      <div>하관</div>
                      <div>下棺</div>
                    </div>
                  </div>
                  <div className="general-funeral-procedures-procedure-content">
                    <h3 className="general-funeral-procedures-procedure-title">하관(下棺)</h3>
                    <p className="general-funeral-procedures-procedure-description">
                      장지에 도착하면 장의차나 상여에서 관을 내려 광중(壙中)에 넣는다. 하관 때는 상주와 복인이 참여하되 곡은 하지 않는다. 광중이란 관을 묻기 위하여 파놓은 구덩이다.
                    </p>
                    <p className="general-funeral-procedures-procedure-description">
                      관을 들어 수평이 되게 하여 좌향(坐向)을 맞춘 다음 반듯하게 내려놓고 명정을 관 위에 덮는다. 그 다음에는 횡대를 차례로 가로 걸친다.
                    </p>
                    <p className="general-funeral-procedures-procedure-description">
                      (유교나 불교는 예단을 드린다) 이때 상주는 취토(取土)를 세 번 외치면서 흙을 관위에 세 번 뿌린다.
                    </p>
                  </div>
                </div>

              </div>
            </div>

            {/* After Funeral */}
            <div className="general-funeral-procedures-day-section">
              <h2 className="general-funeral-procedures-day-title">장례 후</h2>

              <div className="general-funeral-procedures-day-section-content">

                <div className="general-funeral-procedures-procedure">
                  <div className="general-funeral-procedures-procedure-circle">
                    <div className="general-funeral-procedures-procedure-circle-text">
                      <div>삼우</div>
                      <div>三虞</div>
                    </div>
                  </div>
                  <div className="general-funeral-procedures-procedure-content">
                    <h3 className="general-funeral-procedures-procedure-title">삼우(三虞)</h3>
                    <p className="general-funeral-procedures-procedure-description">
                      장례 후 3일째 되는 날에 성묘를 하고 봉분이 잘 되어 있는지 살피고 간단한 제사를 올린다. 이를 삼우라 한다. 요즘은 초우 재우는 생략한다.
                    </p>
                  </div>
                </div>

                <div className="general-funeral-procedures-procedure">
                  <div className="general-funeral-procedures-procedure-circle">
                    <div className="general-funeral-procedures-procedure-circle-text">
                      <div>탈상</div>
                      <div>脫喪</div>
                    </div>
                  </div>
                  <div className="general-funeral-procedures-procedure-content">
                    <h3 className="general-funeral-procedures-procedure-title">탈상(脫喪)</h3>
                    <p className="general-funeral-procedures-procedure-description">
                      상기가 끝난 뒤 복(服)을 벗는 절차이다. 탈상은 부모 조부모 배우자의 경우, 별세한 날로부터 100일까지 이고 그 밖의 경우는 장례일까지 이다. (가정의례준칙) 이때 지내는 제사가 탈상제인데, 제사 지내는 방법은 기제(忌祭)와 동일하다.
                    </p>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>

      </main>
    </div>
  );
};

export default GeneralFuneralProceduresPC; 